export const doctorsEmailsForTest = [
  "karpov@qwe.com",
  "jonasmut@gmail.com",
  "user3@gmail.com"
];

export const patientsEmailsForTest = [
  "user2@gmail.com",
  "alancleyton67@gmail.com",
  "josecarlosbsilva.17@gmail.com",
  "nomarlucena14@gmail.com"
];

export const UFS = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO"
];

export const SPECIALIST_NAMES = {
  "dde51db0-8219-4e09-90a4-fb764503043c": "Acupunturista",
  "810987ad-ca4f-42a0-a500-add6d1f2ad46": "Alergologista e Imunologista",
  "ff5c4f44-08de-4b74-a6d5-b8b9bf388b80":
    "Alergologista e Imunologista Pediátrica",
  "aae9baf1-6c59-4e16-85d7-f4502c28dec5": "Anestesiologia",
  "b2e9920d-76bb-4c08-8088-ebaf3a3fc839": "Angiologista",
  "aea6264a-48b0-40bc-9815-d5e50420de37": "Cardiologista",
  "8f3dac6f-60ef-42fe-acf6-85bd2fbf82a6": "Cirurgião de mão",
  "3be56c61-3da7-4ee5-bf1f-5c7112cfaf7a": "Cirurgião de cabeça e pescoço",
  "d97ec4af-679a-4e25-9f3f-4cc5502f0363": "Cirurgião do aparelho digestivo",
  "0028506b-5c51-4a17-a503-d2eb602ca535": "Cirurgião Geral",
  "903557a6-b59d-4234-9685-1df898ceb189": "Cirurgião Oncológico",
  "96fee6e1-cd53-40ae-9e7c-44c128e0a23d": "Cirurgião Pediátrico",
  "48744198-a58d-427c-b6d7-cc5ff8d44e42": "Cirurgião Plástico",
  "d52569d8-c1ff-4d10-9ff7-e235d22d5b4a": "Cirurgião Torácico",
  "9940895e-fc81-4009-9067-3c29821a2018": "Cirurgião Vascular",
  "3d1314c1-efbb-42e9-b35a-7ba628355109": "Clínico Médico",
  "440c17c1-ef4a-4e17-82f7-a088311dce33": "Clínico Geral",
  "627d18af-1019-4376-b485-43b6f421f7ed": "Coloproctologista",
  "3d996ce8-1045-4e1b-8c01-c933f0e9fb75": "Dentista",
  "487b7464-d387-407f-b44d-fffc501c2b40": "Dermatologista",
  "b87bde6d-6565-4bc8-9865-90629a507b77": "Direito Médico",
  "dde0d2db-9d68-40be-9e58-df779c0955be": "Endocrinologista e Metabologista",
  "f10c3bd7-081a-45ea-888f-55bac1480330": "Endoscopista",
  "99288ff6-13f6-4de6-aef0-f4c6fd07a79f":
    "Enfermeiro(a) (triagem e pre-consulta)",
  "b7f01797-dcec-44f3-a178-e535f166bbb0": "Esteticista Facial",
  "6bc9126e-b3e7-404c-8070-a0b33d4763fb": "Fisioterapeuta",
  "638f7801-b7fc-46c2-9421-1ebaa97420e1": "Fonoaudiólogo(a)",
  "6709b5a2-f3b2-4bf5-9672-be08fadb8915": "Gastroenterologia",
  "1bd449c0-b230-4179-8e51-a34eb4be869b": "Geneticista Médico",
  "c6b461d5-3b74-4105-8c53-f8cd928c16e6": "Geriatra",
  "4d33e7a7-896f-4c5d-b687-6bed3fe7e993": "Ginecologista e Obstetra",
  "32968b1b-e70e-4526-85ee-64cedabd7361": "Hematologista e Hemoterapeuta",
  "50779d9b-2ef9-45ea-9be4-55554f6a7e3b": "Homeopata",
  "67725978-2483-43d9-9420-293bd1d5ca77": "Infectologista",
  "5569e8fe-ca6f-4358-8df0-69160b92f4f5": "Mastologista",
  "4acd0160-24ca-493a-8b71-c35484fbbb3a": "Especialista de Emergência",
  "2cf089f3-4f03-4a6d-996a-dac9fd4d8e08":
    "Especialista de família e comunidade",
  "c6c7dcfc-adcd-44b3-9024-e22abe780c7b": "Especialista de Tráfego",
  "f43a67e4-8315-494f-aa04-155738a7cc58": "Especialista do trabalho",
  "7216fed3-1b70-403b-ae5b-e8d0593edc43": 'Especialista Esportivo"',
  "1b40ed99-a8c0-411e-afe9-427587e441b6": "Especialista Física e Reabilitação",
  "88e71c23-da9a-4700-9203-798777ef8b99": "Especialista de Medicina Intensiva ",
  "686a06a5-b3f0-4ced-9004-e8f6bc97b3e1": "Especialista Legal e Perícia Médica",
  "56fea4b5-ef4d-4351-888e-81834cc7440a": "Especialista de Medicina nuclear",
  "718e483c-2dda-453a-ad81-7c526395eff0": "Especialista Preventivo e Social",
  "2cd742f9-d19d-4bb8-890f-1d71b46e11e1": "Nefrologista",
  "aecf4b6c-bab6-45e6-9c54-602d2c993eac": "Neurocirurgião",
  "38a5ef0d-bb93-4d5f-bbaf-0b4d107d73a2": "Neurologista",
  "56708379-449e-4819-8411-aaa923503f3f": "Nutricionista",
  "d98d3201-d1aa-4a7d-80c5-cf923ee12eb7": "Nutrólogo(a)",
  "d2a1c4b9-6955-4f03-a283-0f16c2ae1176": "Oftalmologista",
  "7ae5c28d-0241-4e51-9b0d-ebafd28184fa": "Oncologista Clínico",
  "f934b298-ccd6-4274-8e8d-27b1c68f9be2": "Ortopedista e Traumatologista",
  "6dde3217-feb3-4d04-aaee-d622e8d54a49": "Otorrinolaringologista",
  "b0e66452-91d7-487b-b7db-0889022dff6e": "Patologista",
  "aa5fb9d0-2ca3-488a-b50f-113bdaf34d8b": "Patologista Clínico/Laboratorial",
  "50bc485f-6817-4dbf-ba52-a7dd78fc6b49": "Pediatra",
  "47bd3d5d-7920-4272-b5fc-2c3b6c398b38": "Pneumologista",
  "eba08f5a-b5f5-46e5-8c9a-ff7b408e7037": "Psicólogo(a)",
  "f17e2324-182d-4182-9f25-182aab125ec3": "Psiquiatra",
  "7123b102-3b52-46a2-a225-20fea5504b7b": "Radiologista",
  "6a5d766e-ffee-487f-944f-63d9692b7958": "Radioterapeuta",
  "dd7051e4-8f51-4ac0-bfb4-b7968bdfa114": "Reumatologista",
  "c625f709-adce-4107-b3fb-5f08b5bb66cf": "Urologista"
};
